const BanzaAvatarPresets = {
  BanzaAvatar: {
    slots: {
      icon: {
        attrs: {
          icon: "mdi:account",
          color: "white"
        }
      }
    },
    presets: {
      outlined: {
        slots: {
          icon: {
            attrs: {
              color: "primary"
            }
          }
        }
      }
    }
  }
};
export {
  BanzaAvatarPresets as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFuemFBdmF0YXJQcmVzZXRzLmpzIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29uc3RhbnRzL2NvbXBvbmVudHMvQmFuemFBdmF0YXJQcmVzZXRzLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IHtcblx0QmFuemFBdmF0YXI6IHtcblx0XHRzbG90czoge1xuXHRcdFx0aWNvbjoge1xuXHRcdFx0XHRhdHRyczoge1xuXHRcdFx0XHRcdGljb246IFwibWRpOmFjY291bnRcIixcblx0XHRcdFx0XHRjb2xvcjogXCJ3aGl0ZVwiLFxuXHRcdFx0XHR9LFxuXHRcdFx0fSxcblx0XHR9LFxuXHRcdHByZXNldHM6IHtcblx0XHRcdG91dGxpbmVkOiB7XG5cdFx0XHRcdHNsb3RzOiB7XG5cdFx0XHRcdFx0aWNvbjoge1xuXHRcdFx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHRcdFx0Y29sb3I6IFwicHJpbWFyeVwiLFxuXHRcdFx0XHRcdFx0fSxcblx0XHRcdFx0XHR9LFxuXHRcdFx0XHR9LFxuXHRcdFx0fSxcblx0XHR9LFxuXHR9LFxufTtcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFlLHFCQUFBO0FBQUEsRUFDZCxhQUFhO0FBQUEsSUFDWixPQUFPO0FBQUEsTUFDTixNQUFNO0FBQUEsUUFDTCxPQUFPO0FBQUEsVUFDTixNQUFNO0FBQUEsVUFDTixPQUFPO0FBQUEsUUFDUDtBQUFBLE1BQ0Q7QUFBQSxJQUNEO0FBQUEsSUFDRCxTQUFTO0FBQUEsTUFDUixVQUFVO0FBQUEsUUFDVCxPQUFPO0FBQUEsVUFDTixNQUFNO0FBQUEsWUFDTCxPQUFPO0FBQUEsY0FDTixPQUFPO0FBQUEsWUFDUDtBQUFBLFVBQ0Q7QUFBQSxRQUNEO0FBQUEsTUFDRDtBQUFBLElBQ0Q7QUFBQSxFQUNEO0FBQ0Y7In0=
